import { styled as muiStyled, Stack, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledCard = muiStyled(Stack)({
  padding: '16px 24px',
  borderRadius: '8px',
  backgroundColor: NEW_COLORS.PRIMARY[25],
});

const StyledTypography = muiStyled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export { StyledCard, StyledTypography };
